export function createMarkup(__html) {
  return {
    __html
  };
}
